import { useEffect } from 'react'
import { getVisorintegrationreportdata, getAllIntegrationconfig, getAllIntegrationreport, getAllIntegrationdictionarykpi, getDailyIntegrationReport  } from '../../../services/sIntegration/integration.service';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const useGetAllVisorintegrationreportdata= (listItemReportData, setListItemReportData, listItemLog, setListItemLog) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getVisorintegrationreportdata();
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setListItemReportData(response.data.l_integration_report_data);
                    setListItemLog(response.data.l_integration_log);
                }
                else {
                    setListItemReportData([]);
                    setListItemLog([]);
                }
            }
            catch (error) {
                setListItemReportData([]);
                    setListItemLog([]);
            }
        }
        
        if (listItemReportData === null && listItemLog === null) {
            getData()
        }
    }, [listItemReportData, setListItemReportData, listItemLog, setListItemLog]);
}

const useGetAllIntegrationconfig= (listItems, setListItems) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getAllIntegrationconfig();
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setListItems(response.data);
                }
                else {
                    setListItems([]);
                }
            }
            catch (error) {
                setListItems([]);
            }
        }
        
        if (listItems === null) {
            getData()
        }
    }, [listItems, setListItems]);
}

const useGetAllIntegrationreport= (listItems, setListItems) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getAllIntegrationreport();
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setListItems(response.data);
                }
                else {
                    setListItems([]);
                }
            }
            catch (error) {
                setListItems([]);
            }
        }
        
        if (listItems === null) {
            getData()
        }
    }, [listItems, setListItems]);
}

const useGetAllIntegrationdictionarykpi= (listItems, setListItems) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getAllIntegrationdictionarykpi();
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setListItems(response.data);
                }
                else {
                    setListItems([]);
                }
            }
            catch (error) {
                setListItems([]);
            }
        }
        
        if (listItems === null) {
            getData()
        }
    }, [listItems, setListItems]);
}


const useOfGetDailyIntegrationReport= (series, setSeries) => {  
    const { t } = useTranslation();

    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getDailyIntegrationReport();
                const response = serviceResponse.data;

                if (response.succeeded) {
                    let aux_series = [];

                    response.data.forEach(element => {
                        aux_series.push({
                            name: t(element.skEventName),
                            data: element.l_dates.map(x => { return {
                                x: moment((x.skEventDate.indexOf('T') !== -1 ? x.skEventDate.split('T')[0] : x.skEventDate)).format('DD/MM/YYYY'),
                                y: x.totalEvents
                            }}),
                        })
                    });

                    setSeries(aux_series);
                }
                else {
                    setSeries([]);
                }
            }
            catch (error) {
                setSeries([]);
            }
        }
        
        if (series === null) {
            getData()
        }
    }, [series, setSeries]);
}


export {
    useGetAllVisorintegrationreportdata,
    useGetAllIntegrationconfig,
    useGetAllIntegrationreport,
    useGetAllIntegrationdictionarykpi,
    useOfGetDailyIntegrationReport
}